export const BASE_API_URL = "https://api.dfg.buildonlinestaging.com/api";
